import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { DeleteErpOrderNFeInput } from './DeleteErpOrderNFeInput';
import { DeleteErpOrderNFeOutput } from './DeleteErpOrderNFeOutput';

export class DeleteErpOrderNFeService extends HttpServiceBase {

  handle = (input: DeleteErpOrderNFeInput): Promise<Result<DeleteErpOrderNFeOutput> | null> => {
    const promise = this.http.delete<Result<DeleteErpOrderNFeOutput>, { userId?: number }>(
      `${this.baseUrlSislogApi}/v2/order/${input.orderId}/erp-order-nfe/${input.erpNfeId}`,
      { userId: input.userId }
    );
    return promise;
  }
}
